module.exports = __webpack_public_path__ + "img/far-user-circle.2bac875e.svg";